export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7556.c888e1f0.jpg";